<template>
  <div class="role-manage">
    <!-- 角色组 -->
    <div class="role-group">
      <div class="role-group-add">
        <span>角色组</span>
        <img class="role-group-add-img" src="../../../../assets/images/role-group/add.png" @click="addRoleGroup">
      </div>
      <div class="role-group-content">
        <div
          class="role-group-item"
          :class="{'role-group-item-active':item.id === roleId}"
          v-for="(item, index) in groupList"
          :key="index"
          @click="selectGroup(item)"
        >
          <div class="role-group-item-name">
            <img v-if="item.id !== roleId" class="role-group-item-user" src="../../../../assets/images/role-group/usergroup.png">
            <img class="role-group-item-user hover-user" :class="{'active-user':item.id == roleId}" src="../../../../assets/images/role-group/usergroup-hign.png">
            <span class="group-name">{{ item.name }}</span>
          </div>
          <el-dropdown
                @command="handleCommand">
            <span class="el-dropdown-link">
              <img v-if="item.id !== roleId" class="role-group-item-more" src="../../../../assets/images/role-group/more.png">
              <img class="role-group-item-more hover-more" :class="{'active-user':item.id == roleId}" src="../../../../assets/images/role-group/more-hign.png">
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(item, 'rename', index)">重命名</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(item, 'delete', index)" class="del-item">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="role-authority">
      <div class="role-authority-top">
        <div class="switch-menu">
          <el-radio-group
            class="menu-name"
            v-for="(item, index) in tabList"
            :key="index"
            v-model="selectedTab"
            >
            <el-radio-button :label="item.name"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="save-btn" @click="saveAuth">
          <img class="save-img" src="../../../../assets/images/role-group/save.png">
          <span>保存设置</span>
        </div>
      </div>

      <!-- 菜单权限 -->
      <div class="role-authority-tree">
        <div class="menu-tree" v-if="isShow && type == 1">
          <AuthTree :type="type" :selectAuth="selectMenuAuth" @getSetAuthList="getSetAuthList"></AuthTree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthTree from '@/components/base/tree/auth-tree.vue';
import Role from '@/models/system/role.js'
import roleMixins from '@/common/mixins/role.js'
export default {
  mixins: [roleMixins],
  components: {
    AuthTree
  },
  data() {
    return {
      roleId: '',
      type: 1,
      selectedTab: '菜单权限',
      tabList: [
        {type:1, name: '菜单权限'}
      ],
      selectMenuAuth: [],
      isShow: true
    }
  },

  created() {
  },

  methods: {
    /**
     * @desc 新增角色组
     */
    addRoleGroup() {
      this.$prompt('', '新增角色', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-gray',
          inputPlaceholder: '请输入角色名称'
        }).then(({ value }) => {
          let data = {
            name: value
          }
          Role.postAddRoleGroup(data).then(res => {
            if (res.success) {
              this.initGroupList()
            } else {
              this.$message.error(res.message);
            }
          })
        }).catch(() => {      
        });
    },
    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command,index){
      return {
        'value': value,
        'command':command,
        'index': index
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "rename":
          this.$prompt('', '重命名', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              confirmButtonClass: 'btn-blue',
              cancelButtonClass: 'btn-gray',
              inputPlaceholder: '请输入角色名称',
              inputValue: command.value.name
            }).then(({ value }) => {
              let data = {
                id: command.value.id,
                name: value
              }
              Role.postModRoleGroup(data).then(res => {
                if (res.success) {
                  this.initGroupList()
                } else {
                  this.$message.error(res.message);
                }
              })
            }).catch(() => {      
            });
          break;
        case "delete":
          this.$confirm("删除后，该角色权限将清空，请确认", "删除", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: 'btn-red',
            cancelButtonClass: 'btn-gray'
          }).then(() => {let data = {
                id: command.value.id
              }
              Role.postDelRoleGroup(data).then(res => {
                if (res.success) {
                  this.roleId = ''
                  this.groupList.splice(command.index, 1)
                } else {
                  this.$message.error(res.message);
                }
              })
          });
          break;
      }
    },

    selectGroup(row) {
      this.roleId = row.id
      this.initRoleAuth()
    },

    getSetAuthList(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id)
      })
      this.selectMenuAuth = arr
    },
    
    /**
     * @desc 保存权限
     */
    saveAuth() {
      let bizRoleId = this.roleId
      let authorityIdList = this.selectMenuAuth
      let data = {
        bizRoleId,
        authorityIdList
      }
      Role.postSaveMenuAuth(data).then(res => {
        if (res.success) {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.message);
        }
      })
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/system/role-manage.scss'; 
</style>
